import React, { useState } from "react";
import "../styles/Login.css"; // Reutilizar estilos del login
import { useNavigate } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS } from "../config/api";
import { apiRequest } from "../utils/apiUtils";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({ email: "" });
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ email: "" });
    setMessage("");

    // Validaciones
    if (!email) {
      setErrors({ email: "El correo electrónico es obligatorio" });
      return;
    }

    if (!validateEmail(email)) {
      setErrors({ email: "Ingresa un correo electrónico válido" });
      return;
    }

    setIsLoading(true);

    try {
      await apiRequest(buildApiUrl(API_ENDPOINTS.forgotPassword), {
        method: "POST",
        body: JSON.stringify({ email }),
      });

      setMessage(
        "Se ha enviado un enlace de recuperación a tu correo electrónico.",
      );
      setEmail("");
    } catch (error) {
      console.error("Error:", error);
      setErrors({
        email: error.message || "Error de conexión. Intenta nuevamente.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
    <div className="login-container">
      <h2>Recuperar Contraseña</h2>
      <p style={{ color: "var(--text-secondary)", fontSize: "11px", marginBottom: "20px" }}>
        Ingresa tu correo electrónico y te enviaremos un enlace para restablecer
        tu contraseña.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <label htmlFor="email">Correo Electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Ingresa tu correo electrónico"
            disabled={isLoading}
          />
          <p className={`error-message ${errors.email ? "visible" : ""}`}>
            {errors.email}
          </p>
        </div>

        {message && (
          <div
            style={{
              color: "var(--accent-color)",
              textAlign: "center",
              marginBottom: "15px",
              fontSize: "11px",
            }}
          >
            {message}
          </div>
        )}

        <button type="submit" disabled={isLoading}>
          {isLoading ? "Enviando..." : "Enviar Enlace"}
        </button>
      </form>

      <div className="login-links-row">
        <button
          type="button"
          className="login-secondary-link"
          onClick={() => navigate("/login")}
        >
          Volver al inicio de sesión
        </button>
      </div>
    </div>
    </div>
  );
};

export default ForgotPassword;
